// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Downloaded-report adoption page. Every colour, radius, and font is taken
 * from globals.css tokens so this page reads as part of the add-in:
 *   --primary-color / --secondary-color  buttons, bar fill, active rows
 *   --dark-color                        headings and the badge
 *   --extremities-color                 header/footer (inherited, not repeated)
 *   --tertiary-bg / --disabled-text     bar track, pending rows
 *   --ai-processing-radius (999px)      the pill-shaped bar + badge
 * Radii follow .signin_error_alert / .signin_continue_button (10-12px) rather
 * than the 4px of the reference design, and the background reuses the
 * .wrapper_signin gradient.
 */

.report_adoption_wrapper {
  position: relative;
  height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;
  overflow-y: auto;
  background:
    radial-gradient(circle at 50% 18%, rgba(125, 215, 235, 0.28), rgba(125, 215, 235, 0) 42%),
    linear-gradient(135deg, #f8fbfd 0%, rgba(125, 215, 235, 0.22) 100%);
}

.report_adoption_panel {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  box-sizing: border-box;
}

/* Brand — same treatment as .signin_brand_name, scaled down for a taskpane. */
.report_adoption_brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
}

.report_adoption_logo {
  width: 96px;
  height: 96px;
  object-fit: contain;
  filter: drop-shadow(0 10px 12px rgba(0, 105, 165, 0.16));
}

.report_adoption_brand_name {
  color: var(--dark-color);
  font-size: var(--ui-font-title-sm);
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0;
}

/* Percent + phase + live stage, in the screenshot's vertical order. */
.report_adoption_percent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  text-align: center;
}

.report_adoption_percent_value {
  color: var(--dark-color);
  font-size: var(--ui-font-display-sm-tight);
  font-weight: 700;
  line-height: 1.05;
  font-variant-numeric: tabular-nums;
}

.report_adoption_phase {
  color: var(--primary-color);
  font-size: var(--ui-font-sm-plus);
  font-weight: 500;
  line-height: 1.2;
}

.report_adoption_stage {
  color: #3f4a54;
  font-size: var(--ui-font-sm);
  line-height: 1.35;
  min-height: 1.35em;
  animation: ai-processing-text-pulse 1.15s ease-in-out infinite;
}

/* Bar + floating badge. Badge is translateX(-50%) so it tracks the fill edge
   and stays inside the panel at both 0% and 100%. */
.report_adoption_bar_wrap {
  position: relative;
  width: 100%;
  margin-top: 0.35rem;
}

.report_adoption_bar {
  width: 100%;
  height: 8px;
  border-radius: var(--ai-processing-radius, 999px);
  background: rgba(6, 42, 63, 0.1);
  overflow: hidden;
}

.report_adoption_bar_fill {
  height: 100%;
  border-radius: var(--ai-processing-radius, 999px);
  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  transition: width 0.35s cubic-bezier(0.22, 0.9, 0.3, 1);
}

/* Throughput-based remaining-time estimate under the bar. Styled as a refined
   telemetry pill with subtle brand tint, border, and clock glyph. */
.report_adoption_eta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.22rem 0.75rem;
  border-radius: 999px;
  background: rgba(0, 105, 165, 0.05);
  border: 1px solid rgba(0, 105, 165, 0.12);
  color: #2c4456;
  font-size: var(--ui-font-xs-plus);
  font-weight: 500;
  line-height: 1.25;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
  animation: report-adoption-fade-in 0.25s ease-out;
}

.report_adoption_eta_icon {
  font-size: 11px;
  color: var(--primary-color);
  opacity: 0.85;
}

@keyframes report-adoption-fade-in {
  from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Screen-reader-only mirror of the idle card's placeholder so the live region
   announces "Processing…" during the zero-unit window. */
.report_adoption_sr_only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

/* Current section headline. */
.report_adoption_current {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
  padding: 0.5rem 0.65rem;
  box-sizing: border-box;
  /* One of the two white surfaces kept after the panel card was removed: the
     gradient behind it is too close to #f8f9fa to give dense text an edge. */
  border: 1px solid rgba(0, 105, 165, 0.14);
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 60, 100, 0.06);
  text-align: center;
}

.report_adoption_current_index {
  color: var(--primary-color);
  font-size: var(--ui-font-xs-plus);
  font-weight: 600;
  line-height: 1.3;
}

.report_adoption_current_name {
  color: var(--dark-color);
  font-size: var(--ui-font-md);
  font-weight: 500;
  line-height: 1.25;
}

.report_adoption_current_markers {
  color: #3f4a54;
  font-size: var(--ui-font-xs-plus);
  line-height: 1.3;
  font-variant-numeric: tabular-nums;
}

.report_adoption_current--idle {
  color: #3f4a54;
  font-size: var(--ui-font-sm);
  line-height: 1.3;
  font-variant-numeric: tabular-nums;
}

/* Per-section list. Capped and scrollable so a 20-section report does not
   push the percent and bar out of view. */
.report_adoption_list {
  width: 100%;
  max-height: 168px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
  /* The second white surface: rows need a defined boundary once there is no
     wrapping card to sit on. */
  border: 1px solid rgba(0, 105, 165, 0.14);
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 60, 100, 0.06);
  box-sizing: border-box;
}

.report_adoption_list::-webkit-scrollbar {
  width: 6px;
}

.report_adoption_list::-webkit-scrollbar-thumb {
  border-radius: var(--ai-processing-radius, 999px);
  background: var(--tertiary-bg, #d6d6d6);
}

.report_adoption_item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.5rem;
  font-size: var(--ui-font-sm);
  line-height: 1.3;
}

.report_adoption_item_icon {
  flex: 0 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 1;
}

.report_adoption_item_name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report_adoption_item_state {
  flex: 0 0 auto;
  font-size: var(--ui-font-xs);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* Use green for the "X citations..." text (and done
   checkmark) and orange for "No citations" so cited sections visibly stand
   apart from sections without citations. */
.report_adoption_item--done .report_adoption_item_icon,
.report_adoption_item--done .report_adoption_item_state:not(.report_adoption_item_state--no-citations) {
  color: #15803d;
  font-weight: 500;
}

/* Zero citations on a finished section is a real signal that the section
   has nothing to link — use orange so the row reads as "needs attention",
   separate from the green cited sections. */
.report_adoption_item--done .report_adoption_item_state--no-citations {
  color: #ea580c;
  font-weight: 500;
}

.report_adoption_item--active {
  background: rgba(0, 105, 165, 0.08);
  border-radius: 8px;
}

.report_adoption_item--active .report_adoption_item_icon,
.report_adoption_item--active .report_adoption_item_state {
  color: var(--primary-color);
}

.report_adoption_item--active .report_adoption_item_name {
  color: var(--dark-color);
  font-weight: 500;
}

.report_adoption_item_pulse {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--primary-color);
  animation: report-adoption-dot 1.2s ease-in-out infinite;
}

.report_adoption_item--pending .report_adoption_item_icon,
.report_adoption_item--pending .report_adoption_item_state {
  color: var(--disabled-text, #a3a3a3);
}

.report_adoption_item--pending .report_adoption_item_name {
  color: rgba(6, 42, 63, 0.55);
}

/* Failure — reuses .signin_error_alert's red treatment. */
.report_adoption_error {
  width: 100%;
  margin-top: 0.15rem;
  padding: 0.65rem 0.75rem;
  box-sizing: border-box;
  border: 1px solid rgba(180, 35, 24, 0.18);
  border-radius: 10px;
  background: rgba(254, 242, 242, 0.78);
  color: #b42318;
  font-size: var(--ui-font-sm);
  line-height: 1.35;
  text-align: left;
}

.report_adoption_error_head {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  font-weight: 500;
}

.report_adoption_error_hint {
  margin: 0.35rem 0 0;
  font-size: var(--ui-font-xs-plus);
  line-height: 1.35;
}

.report_adoption_retry {
  width: 100%;
  min-height: 36px;
  margin-top: 0.55rem;
  border: 0;
  border-radius: 10px;
  background: var(--primary-color);
  color: #ffffff;
  font-size: var(--ui-font-sm-plus);
  font-weight: 500;
  box-shadow: none;
}

.report_adoption_retry:not(:disabled):hover,
.report_adoption_retry:not(:disabled):focus {
  background: var(--secondary-color) !important;
  color: var(--dark-color) !important;
}

@keyframes report-adoption-dot {
  0%,
  100% {
    opacity: 0.3;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-2px);
  }
}

/* Narrow taskpane: drop the logo block and shrink the numeral so the percent,
   bar, and current-section card all stay above the fold. */
@media (max-width: 360px) {
  .report_adoption_panel {
    gap: 0.6rem;
  }

  .report_adoption_logo {
    width: 64px;
    height: 64px;
  }

  .report_adoption_percent_value {
    font-size: var(--ui-font-title-accent);
  }

  .report_adoption_list {
    max-height: 140px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .report_adoption_stage,
  .report_adoption_item_pulse {
    animation: none;
  }

  .report_adoption_bar_fill {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ReportAdoptionPage.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;;AAEF;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB;;uEAEqE;AACvE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;oDACoD;AACpD;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iDAAiD;EACjD,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iDAAiD;EACjD,wFAAwF;EACxF,uDAAuD;AACzD;;AAEA;oEACoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;yDACyD;AACzD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB;6EAC2E;EAC3E,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;0CAC0C;AAC1C;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;+BAC6B;EAC7B,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iDAAiD;EACjD,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;2CAE2C;AAC3C;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;4CAE4C;AAC5C;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE;;IAEE,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;2DAC2D;AAC3D;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Downloaded-report adoption page. Every colour, radius, and font is taken\n * from globals.css tokens so this page reads as part of the add-in:\n *   --primary-color / --secondary-color  buttons, bar fill, active rows\n *   --dark-color                        headings and the badge\n *   --extremities-color                 header/footer (inherited, not repeated)\n *   --tertiary-bg / --disabled-text     bar track, pending rows\n *   --ai-processing-radius (999px)      the pill-shaped bar + badge\n * Radii follow .signin_error_alert / .signin_continue_button (10-12px) rather\n * than the 4px of the reference design, and the background reuses the\n * .wrapper_signin gradient.\n */\n\n.report_adoption_wrapper {\n  position: relative;\n  height: calc(100vh - 80px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  box-sizing: border-box;\n  overflow-y: auto;\n  background:\n    radial-gradient(circle at 50% 18%, rgba(125, 215, 235, 0.28), rgba(125, 215, 235, 0) 42%),\n    linear-gradient(135deg, #f8fbfd 0%, rgba(125, 215, 235, 0.22) 100%);\n}\n\n.report_adoption_panel {\n  width: 100%;\n  max-width: 360px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n  box-sizing: border-box;\n}\n\n/* Brand — same treatment as .signin_brand_name, scaled down for a taskpane. */\n.report_adoption_brand {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.report_adoption_logo {\n  width: 96px;\n  height: 96px;\n  object-fit: contain;\n  filter: drop-shadow(0 10px 12px rgba(0, 105, 165, 0.16));\n}\n\n.report_adoption_brand_name {\n  color: var(--dark-color);\n  font-size: var(--ui-font-title-sm);\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: 0;\n}\n\n/* Percent + phase + live stage, in the screenshot's vertical order. */\n.report_adoption_percent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.2rem;\n  text-align: center;\n}\n\n.report_adoption_percent_value {\n  color: var(--dark-color);\n  font-size: var(--ui-font-display-sm-tight);\n  font-weight: 700;\n  line-height: 1.05;\n  font-variant-numeric: tabular-nums;\n}\n\n.report_adoption_phase {\n  color: var(--primary-color);\n  font-size: var(--ui-font-sm-plus);\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n.report_adoption_stage {\n  color: #3f4a54;\n  font-size: var(--ui-font-sm);\n  line-height: 1.35;\n  min-height: 1.35em;\n  animation: ai-processing-text-pulse 1.15s ease-in-out infinite;\n}\n\n/* Bar + floating badge. Badge is translateX(-50%) so it tracks the fill edge\n   and stays inside the panel at both 0% and 100%. */\n.report_adoption_bar_wrap {\n  position: relative;\n  width: 100%;\n  margin-top: 0.35rem;\n}\n\n.report_adoption_bar {\n  width: 100%;\n  height: 8px;\n  border-radius: var(--ai-processing-radius, 999px);\n  background: rgba(6, 42, 63, 0.1);\n  overflow: hidden;\n}\n\n.report_adoption_bar_fill {\n  height: 100%;\n  border-radius: var(--ai-processing-radius, 999px);\n  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  transition: width 0.35s cubic-bezier(0.22, 0.9, 0.3, 1);\n}\n\n/* Throughput-based remaining-time estimate under the bar. Styled as a refined\n   telemetry pill with subtle brand tint, border, and clock glyph. */\n.report_adoption_eta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  padding: 0.22rem 0.75rem;\n  border-radius: 999px;\n  background: rgba(0, 105, 165, 0.05);\n  border: 1px solid rgba(0, 105, 165, 0.12);\n  color: #2c4456;\n  font-size: var(--ui-font-xs-plus);\n  font-weight: 500;\n  line-height: 1.25;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.01em;\n  animation: report-adoption-fade-in 0.25s ease-out;\n}\n\n.report_adoption_eta_icon {\n  font-size: 11px;\n  color: var(--primary-color);\n  opacity: 0.85;\n}\n\n@keyframes report-adoption-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-2px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Screen-reader-only mirror of the idle card's placeholder so the live region\n   announces \"Processing…\" during the zero-unit window. */\n.report_adoption_sr_only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Current section headline. */\n.report_adoption_current {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.1rem;\n  padding: 0.5rem 0.65rem;\n  box-sizing: border-box;\n  /* One of the two white surfaces kept after the panel card was removed: the\n     gradient behind it is too close to #f8f9fa to give dense text an edge. */\n  border: 1px solid rgba(0, 105, 165, 0.14);\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0 1px 3px rgba(0, 60, 100, 0.06);\n  text-align: center;\n}\n\n.report_adoption_current_index {\n  color: var(--primary-color);\n  font-size: var(--ui-font-xs-plus);\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.report_adoption_current_name {\n  color: var(--dark-color);\n  font-size: var(--ui-font-md);\n  font-weight: 500;\n  line-height: 1.25;\n}\n\n.report_adoption_current_markers {\n  color: #3f4a54;\n  font-size: var(--ui-font-xs-plus);\n  line-height: 1.3;\n  font-variant-numeric: tabular-nums;\n}\n\n.report_adoption_current--idle {\n  color: #3f4a54;\n  font-size: var(--ui-font-sm);\n  line-height: 1.3;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Per-section list. Capped and scrollable so a 20-section report does not\n   push the percent and bar out of view. */\n.report_adoption_list {\n  width: 100%;\n  max-height: 168px;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  /* The second white surface: rows need a defined boundary once there is no\n     wrapping card to sit on. */\n  border: 1px solid rgba(0, 105, 165, 0.14);\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0 1px 3px rgba(0, 60, 100, 0.06);\n  box-sizing: border-box;\n}\n\n.report_adoption_list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.report_adoption_list::-webkit-scrollbar-thumb {\n  border-radius: var(--ai-processing-radius, 999px);\n  background: var(--tertiary-bg, #d6d6d6);\n}\n\n.report_adoption_item {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.3rem 0.5rem;\n  font-size: var(--ui-font-sm);\n  line-height: 1.3;\n}\n\n.report_adoption_item_icon {\n  flex: 0 0 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  line-height: 1;\n}\n\n.report_adoption_item_name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.report_adoption_item_state {\n  flex: 0 0 auto;\n  font-size: var(--ui-font-xs);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n/* Use green for the \"X citations...\" text (and done\n   checkmark) and orange for \"No citations\" so cited sections visibly stand\n   apart from sections without citations. */\n.report_adoption_item--done .report_adoption_item_icon,\n.report_adoption_item--done .report_adoption_item_state:not(.report_adoption_item_state--no-citations) {\n  color: #15803d;\n  font-weight: 500;\n}\n\n/* Zero citations on a finished section is a real signal that the section\n   has nothing to link — use orange so the row reads as \"needs attention\",\n   separate from the green cited sections. */\n.report_adoption_item--done .report_adoption_item_state--no-citations {\n  color: #ea580c;\n  font-weight: 500;\n}\n\n.report_adoption_item--active {\n  background: rgba(0, 105, 165, 0.08);\n  border-radius: 8px;\n}\n\n.report_adoption_item--active .report_adoption_item_icon,\n.report_adoption_item--active .report_adoption_item_state {\n  color: var(--primary-color);\n}\n\n.report_adoption_item--active .report_adoption_item_name {\n  color: var(--dark-color);\n  font-weight: 500;\n}\n\n.report_adoption_item_pulse {\n  display: block;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--primary-color);\n  animation: report-adoption-dot 1.2s ease-in-out infinite;\n}\n\n.report_adoption_item--pending .report_adoption_item_icon,\n.report_adoption_item--pending .report_adoption_item_state {\n  color: var(--disabled-text, #a3a3a3);\n}\n\n.report_adoption_item--pending .report_adoption_item_name {\n  color: rgba(6, 42, 63, 0.55);\n}\n\n/* Failure — reuses .signin_error_alert's red treatment. */\n.report_adoption_error {\n  width: 100%;\n  margin-top: 0.15rem;\n  padding: 0.65rem 0.75rem;\n  box-sizing: border-box;\n  border: 1px solid rgba(180, 35, 24, 0.18);\n  border-radius: 10px;\n  background: rgba(254, 242, 242, 0.78);\n  color: #b42318;\n  font-size: var(--ui-font-sm);\n  line-height: 1.35;\n  text-align: left;\n}\n\n.report_adoption_error_head {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  font-weight: 500;\n}\n\n.report_adoption_error_hint {\n  margin: 0.35rem 0 0;\n  font-size: var(--ui-font-xs-plus);\n  line-height: 1.35;\n}\n\n.report_adoption_retry {\n  width: 100%;\n  min-height: 36px;\n  margin-top: 0.55rem;\n  border: 0;\n  border-radius: 10px;\n  background: var(--primary-color);\n  color: #ffffff;\n  font-size: var(--ui-font-sm-plus);\n  font-weight: 500;\n  box-shadow: none;\n}\n\n.report_adoption_retry:not(:disabled):hover,\n.report_adoption_retry:not(:disabled):focus {\n  background: var(--secondary-color) !important;\n  color: var(--dark-color) !important;\n}\n\n@keyframes report-adoption-dot {\n  0%,\n  100% {\n    opacity: 0.3;\n    transform: translateY(0);\n  }\n  40% {\n    opacity: 1;\n    transform: translateY(-2px);\n  }\n}\n\n/* Narrow taskpane: drop the logo block and shrink the numeral so the percent,\n   bar, and current-section card all stay above the fold. */\n@media (max-width: 360px) {\n  .report_adoption_panel {\n    gap: 0.6rem;\n  }\n\n  .report_adoption_logo {\n    width: 64px;\n    height: 64px;\n  }\n\n  .report_adoption_percent_value {\n    font-size: var(--ui-font-title-accent);\n  }\n\n  .report_adoption_list {\n    max-height: 140px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .report_adoption_stage,\n  .report_adoption_item_pulse {\n    animation: none;\n  }\n\n  .report_adoption_bar_fill {\n    transition: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
